import { VideoCallI } from "@interfaces/videocall/videocall";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICameraVideoTrack, IMicrophoneAudioTrack } from "agora-rtc-sdk-ng";

interface IVideoCallSlice 
{ 
    videoCall: VideoCallI | undefined, 
    audioTrack: IMicrophoneAudioTrack | undefined, 
    videoTrack: ICameraVideoTrack | undefined ,
    answered: boolean
}

export const videoCallSlice = createSlice({
    name: 'videoCall',
    initialState:{
        videoCall: undefined,
        audioTrack: undefined,
        videoTrack: undefined,
        answered: false
    } as IVideoCallSlice,
    reducers: {
        setCurrentVideoCall: (state, action: PayloadAction<VideoCallI | undefined>) => {
            if(action.payload){
                state.videoCall = {...action.payload};
            }else{
                state.videoCall = undefined;
                state.answered = false;
            }
        },
        setCurrentAudioTrack: (state, action: PayloadAction<IMicrophoneAudioTrack | undefined>) => {
            if(action.payload){
                state.audioTrack = action.payload;
            }else{
                state.audioTrack = undefined;
            }
        },
        setAnswered: (state, action: PayloadAction<boolean>) => {
            state.answered = action.payload;
        },
        setCurrentVideoTrack: (state, action: PayloadAction<ICameraVideoTrack | undefined>) => {
            if(action.payload){
                state.videoTrack = action.payload
            }else{
                state.videoTrack = undefined;
            }
        },
        setCleanVideoCall: (state) =>{
            state.videoCall = undefined;
            state.audioTrack = undefined;
            state.videoTrack = undefined;
            state.answered = false;
        }
    },
});

export const { setCurrentVideoCall, setCurrentAudioTrack, setCurrentVideoTrack, setCleanVideoCall, setAnswered } = videoCallSlice.actions;
export default videoCallSlice.reducer;